import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecitycab() {



  const cardData = {


  keyword: "Mumbai Airport to Pune City Cab",

  headingDescription: "Trustline Cab provides reliable Mumbai Airport to Pune City cab services with safe, comfortable, and affordable transportation for airport transfers, business travel, corporate meetings, family trips, and outstation journeys. Whether you are arriving at Mumbai Airport for work or leisure, our professional chauffeurs ensure timely pickup, smooth highway travel, and a hassle-free journey to Pune City. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With flight-friendly scheduling, doorstep pickup, transparent pricing, easy online booking, experienced drivers, well-maintained cars, and 24/7 customer support, Trustline Travels is your trusted choice for Mumbai Airport to Pune taxi services.",

  topPlaces: [
    {
      title: "Shivajinagar",
      description: "Shivajinagar is one of Pune's central commercial areas, featuring corporate offices, educational institutions, government establishments, shopping markets, and excellent connectivity. It is a preferred destination for business travelers and city visitors."
    },
    {
      title: "Koregaon Park",
      description: "Koregaon Park is a premium Pune locality known for luxury hotels, restaurants, cafés, business centers, and vibrant lifestyle destinations. It attracts corporate professionals, tourists, and international visitors."
    },
    {
      title: "Kalyani Nagar",
      description: "Kalyani Nagar is a well-developed commercial and residential area featuring IT companies, business parks, luxury hotels, restaurants, and modern infrastructure. It is popular among professionals and corporate travelers."
    },
    {
      title: "Aundh",
      description: "Aundh is a premium residential and commercial locality in Pune offering corporate offices, educational institutes, hospitals, shopping areas, and excellent connectivity to major city destinations."
    },
    {
      title: "Balewadi",
      description: "Balewadi is a rapidly developing area known for Balewadi High Street, commercial spaces, sports facilities, restaurants, and premium residential projects. It is a preferred destination for professionals and visitors."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport connects the city with major destinations across India and is an important location for business travelers, tourists, and passengers requiring airport transfer services."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous religious and cultural landmarks, attracting thousands of devotees and tourists every year due to its heritage and spiritual importance."
    },
    {
      title: "Pataleshwar Cave Temple",
      description: "Pataleshwar Cave Temple is an ancient rock-cut temple in Pune known for its historic architecture, stone carvings, and peaceful atmosphere. It is a popular attraction for history and culture lovers."
    },
    {
      title: "Sinhagad Fort",
      description: "Sinhagad Fort is a historic hill fort near Pune offering scenic views, trekking opportunities, and a glimpse into Maharashtra's rich history. It is a popular weekend destination for adventure enthusiasts."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a beautiful hill station between Mumbai and Pune, famous for waterfalls, lush green valleys, viewpoints, and pleasant weather. It is a popular sightseeing destination for travelers."
    }
  ],






"services": [
  {
    "name": "Mumbai Airport to Kothrud Cab",
    "description": "Book Mumbai Airport to Kothrud Cab for comfortable airport transfers with professional chauffeurs, clean AC vehicles, affordable fares, doorstep pickup, and reliable travel service for business and family journeys."
  },
  {
    "name": "Mumbai Airport to Kondhwa Cab",
    "description": "Choose Mumbai Airport to Kondhwa Cab for safe and convenient airport travel with experienced drivers, premium cars, transparent pricing, and smooth highway transportation."
  },
  {
    "name": "Mumbai Airport to Koregaon Park Cab",
    "description": "Reserve Mumbai Airport to Koregaon Park Cab with comfortable Sedan, Ertiga, Innova Crysta, and SUV options for airport pickup, business trips, and private travel."
  },
  {
    "name": "Mumbai Airport to Viman Nagar Cab",
    "description": "Book Mumbai Airport to Viman Nagar Cab for reliable airport transfers with punctual pickup, AC vehicles, professional drivers, and affordable pricing."
  },
  {
    "name": "Mumbai Airport to Baner Taxi Fare",
    "description": "Check Mumbai Airport to Baner Taxi Fare with transparent rates, fixed pricing, multiple vehicle options, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Mumbai Airport to Aundh Cab Fare",
    "description": "Get Mumbai Airport to Aundh Cab Fare details with affordable packages, premium vehicles, professional chauffeurs, and no hidden charges."
  },
  {
    "name": "Mumbai Airport to Kharadi Taxi",
    "description": "Book Mumbai Airport to Kharadi Taxi for corporate travel, IT park transfers, and personal journeys with clean cars and experienced drivers."
  },
  {
    "name": "Mumbai Airport to Wagholi Cab Service",
    "description": "Choose Mumbai Airport to Wagholi Cab Service for safe airport transportation with comfortable vehicles, timely pickup, and reliable customer support."
  },
  {
    "name": "Mumbai Airport to Magarpatta Cab Service",
    "description": "Book Mumbai Airport to Magarpatta Cab Service with professional chauffeurs, premium AC cars, affordable fares, and smooth airport connectivity."
  },
  {
    "name": "Mumbai Airport Cab Service",
    "description": "Our Mumbai Airport Cab Service provides reliable airport pickup and drop with clean vehicles, trained drivers, affordable pricing, and 24x7 booking support."
  },
  {
    "name": "Mumbai Airport Car Rental",
    "description": "Choose Mumbai Airport Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury cars for airport transfers and outstation travel."
  },
  {
    "name": "Mumbai Airport Transfer",
    "description": "Book Mumbai Airport Transfer service for comfortable and punctual transportation with professional drivers, AC vehicles, luggage assistance, and doorstep pickup."
  },
  {
    "name": "Airport Taxi Mumbai",
    "description": "Get Airport Taxi Mumbai service for reliable airport travel with experienced chauffeurs, affordable fares, clean vehicles, and easy booking options."
  },
  {
    "name": "Mumbai Airport Taxi",
    "description": "Book Mumbai Airport Taxi for convenient airport pickup and drop with premium vehicles, transparent pricing, and professional drivers."
  },
  {
    "name": "Mumbai Airport Taxi Booking",
    "description": "Complete Mumbai Airport Taxi Booking online with instant confirmation, flexible schedules, multiple car options, and dependable airport transportation."
  },
  {
    "name": "Car Hire Mumbai Airport",
    "description": "Hire Car at Mumbai Airport with chauffeur-driven vehicles for corporate travel, family trips, airport transfers, and private journeys."
  },
  {
    "name": "Mumbai to Shirdi Taxi Service",
    "description": "Book Mumbai to Shirdi Taxi Service for comfortable pilgrimage and outstation travel with experienced drivers, premium cars, and affordable fares."
  },
  {
    "name": "Airport Cabs Mumbai",
    "description": "Choose Airport Cabs Mumbai for reliable transportation with Sedan, Ertiga, Innova Crysta, SUV options, professional chauffeurs, and timely service."
  },
  {
    "name": "Cab from Pune to Mumbai Airport",
    "description": "Book Cab from Pune to Mumbai Airport with comfortable AC vehicles, experienced drivers, fixed fares, and hassle-free airport transfers."
  },
  {
    "name": "Mumbai Airport Taxi Service",
    "description": "Reserve Mumbai Airport Taxi Service for safe and convenient airport travel with professional chauffeurs, clean cars, and affordable pricing."
  },
  {
    "name": "Taxi from Pune to Mumbai Airport",
    "description": "Choose Taxi from Pune to Mumbai Airport for reliable airport transfers with doorstep pickup, premium vehicles, and comfortable long-distance travel."
  },
  {
    "name": "Prepaid Taxi Mumbai Airport",
    "description": "Book Prepaid Taxi Mumbai Airport service with transparent fares, professional drivers, fixed pricing, and secure airport transportation."
  },
  {
    "name": "Mumbai Airport to Kolhapur Cab Service",
    "description": "Travel with Mumbai Airport to Kolhapur Cab Service featuring comfortable cars, experienced chauffeurs, affordable fares, and reliable outstation travel."
  },
  {
    "name": "Mumbai Airport to Pune Station Cab Service",
    "description": "Book Mumbai Airport to Pune Station Cab Service for smooth railway transfers with timely pickup, luggage support, and comfortable AC vehicles."
  },
  {
    "name": "Mumbai Airport to Pune Cab",
    "description": "Book Mumbai Airport to Pune Cab for safe intercity travel with premium cars, professional drivers, transparent pricing, and 24x7 support."
  },
  {
    "name": "Mumbai Airport to Pune Taxi",
    "description": "Choose Mumbai Airport to Pune Taxi for affordable airport transfers with Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Mumbai Airport to Pune One Way Cab",
    "description": "Reserve Mumbai Airport to Pune One Way Cab for direct drop service with affordable fares, clean vehicles, and experienced chauffeurs."
  }
],

"tableData": [
  ["Mumbai Airport to Kothrud Cab", "Mumbai Airport to Kondhwa Cab"],
  ["Mumbai Airport to Koregaon Park Cab", "Mumbai Airport to Viman Nagar Cab"],
  ["Mumbai Airport to Baner Taxi Fare", "Mumbai Airport to Aundh Cab Fare"],
  ["Mumbai Airport to Kharadi Taxi", "Mumbai Airport to Wagholi Cab Service"],
  ["Mumbai Airport to Magarpatta Cab Service", "Mumbai Airport Cab Service"],
  ["Mumbai Airport Car Rental", "Mumbai Airport Transfer"],
  ["Airport Taxi Mumbai", "Mumbai Airport Taxi"],
  ["Mumbai Airport Taxi Booking", "Car Hire Mumbai Airport"],
  ["Mumbai to Shirdi Taxi Service", "Airport Cabs Mumbai"],
  ["Cab from Pune to Mumbai Airport", "Mumbai Airport Taxi Service"],
  ["Taxi from Pune to Mumbai Airport", "Prepaid Taxi Mumbai Airport"],
  ["Mumbai Airport to Kolhapur Cab Service", "Mumbai Airport to Pune Station Cab Service"],
  ["Mumbai Airport to Pune Cab", "Mumbai Airport to Pune Taxi"],
  ["Mumbai Airport to Pune One Way Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Airport to Pune City Cab",
    WhyChoosedescription: "Trustline Cab provides comfortable Mumbai Airport to Pune City cab services with professional drivers, clean vehicles, and timely airport transfers."
  },
  {
    WhyChooseheading: "Direct Airport Pickup to Pune City",
    WhyChoosedescription: "Enjoy hassle-free travel with direct pickup from Mumbai Airport Terminal 1 and Terminal 2 to any location across Pune City."
  },
  {
    WhyChooseheading: "Flight Schedule Based Cab Service",
    WhyChoosedescription: "Our drivers coordinate according to your flight arrival time to ensure smooth pickup and comfortable travel after landing."
  },
  {
    WhyChooseheading: "Comfortable Cars with Luggage Space",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for a comfortable airport journey."
  },
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Our trained chauffeurs provide safe driving, route expertise, and professional assistance throughout your Mumbai to Pune trip."
  },
  {
    WhyChooseheading: "Clear & Affordable Cab Pricing",
    WhyChoosedescription: "Get transparent fare details before booking with competitive pricing and no hidden charges for your airport transfer."
  },
  {
    WhyChooseheading: "Suitable for Every Type of Traveler",
    WhyChoosedescription: "Our Mumbai Airport to Pune City cabs are perfect for families, corporate executives, tourists, students, and business travelers."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Book your airport cab anytime with quick confirmation and reliable customer support for early morning or late-night flights."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mumbai Airport to Pune City cab service?",
    answer: "Yes, Trustline Cab offers reliable cab services from Mumbai Airport to Pune City with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a cab from Mumbai Airport Terminal 1 and Terminal 2 to Pune?",
    answer: "Yes, we provide direct pickup services from both Mumbai Airport Terminal 1 and Terminal 2 to all major areas of Pune City."
  },
  {
    question: "Which vehicles are available for Mumbai Airport to Pune City travel?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to passenger and luggage requirements."
  },
  {
    question: "Can I schedule pickup according to my flight arrival time?",
    answer: "Yes, cab pickup can be arranged according to your flight timing for a convenient airport transfer experience."
  },
  {
    question: "Is Mumbai Airport to Pune City one-way cab service available?",
    answer: "Yes, we provide affordable one-way airport transfer cabs from Mumbai Airport to Pune City."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, airport parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking fare."
  },
  {
    question: "Is Mumbai Airport to Pune City cab service available 24 hours?",
    answer: "Yes, our airport cab service operates 24/7 for convenient travel according to your flight schedule."
  },
  {
    question: "Should I book my airport cab in advance?",
    answer: "Advance booking is recommended to ensure vehicle availability and timely pickup after your flight arrival."
  },
  {
    question: "Is this service suitable for corporate and family passengers?",
    answer: "Yes, our airport transfer service is suitable for corporate travelers, families, tourists, and passengers carrying extra luggage."
  },
  {
    question: "How can I book Mumbai Airport to Pune City Cab with Trustline Travels?",
    answer: "Share your flight details, pickup terminal, Pune destination, travel date, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Verma",
    feedback: "The airport transfer from Mumbai Airport to Pune City was very smooth. The driver arrived on time, the cab was comfortable, and the entire journey was handled professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aditi More",
    feedback: "Excellent service with quick communication, clean vehicle, and a polite driver. Trustline Travels made our airport journey to Pune City comfortable and completely stress-free.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune City Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/mumbai-airport-to-pune-city-cab.webp",
  "description": "Book Mumbai Airport to Pune City cab service with Trustline Travels for safe, comfortable, and reliable airport transfers. Get affordable airport taxi services from Mumbai Airport to Pune areas including Kothrud, Kondhwa, Koregaon Park, Viman Nagar, Baner, Aundh, Kharadi, Wagholi, and Magarpatta with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mumbai-airport-to-pune-city-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai Airport to Pune City Cab | Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Pune City cab with Trustline Travels for reliable airport transfers. Get affordable taxi services from Mumbai Airport to Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="mumbai airport to kothrud cab, mumbai airport to kondhwa cab, mumbai airport to koregaon park cab, mumbai airport to viman nagar cab, mumbai airport to baner taxi fare, mumbai airport to aundh cab fare, mumbai airport to kharadi taxi, mumbai airport to wagholi cab service, mumbai airport to magarpatta cab, Mumbai Airport to Pune City Cab, Mumbai Airport Pune Taxi Service, Mumbai Airport to Pune Cab Booking, Mumbai Airport Pune One Way Taxi, Mumbai Airport Pune Airport Transfer"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/102.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecitycab;